import { useQuery } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import api from '@pray/shared/utils/api';
import type { OffsetInfiniteQueryParams } from '@pray/shared/utils/api/types/fetch';
import { PaginatedListResponse } from '@pray/shared/utils/api/types/response';
import storage from '@pray/shared/utils/storage';

import type { ArtistResponse } from './types';

// TODO: refactor executeGetRequest options type to easy export that
type GetArtistsPropsOptions = Parameters<typeof api.executeGetRequest>[2];
type GetArtistsProps = {
  search?: string;
  offset?: number;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc';
  options?: GetArtistsPropsOptions;
};

type GetArtistsResponse = PaginatedListResponse<ArtistResponse>;

export async function getArtists({
  search = '',
  offset = 0,
  sortColumn = '',
  sortDirection = 'asc',
  options = {},
}: GetArtistsProps = {}) {
  const params: OffsetInfiniteQueryParams = {};

  if (search) {
    params.search = search;
  } else if (offset) {
    params.offset = offset;
  }

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists`;
  const response = await api.executeGetRequest<GetArtistsResponse>(url, params, options);

  return response.data;
}

type UseArtistsProps = {
  search?: string;
  offset?: number;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc';
};

export function useArtists({ search = '', offset = 0, sortColumn = '', sortDirection = 'asc' }: UseArtistsProps = {}) {
  const user = storage.getUser();

  const query = useQuery({
    enabled: !!user?.is_registered,
    queryKey: queryKeys.artists({ search, offset, sortColumn, sortDirection }),
    queryFn: () => getArtists({ search, offset, sortColumn, sortDirection }),
  });

  return query;
}
